import React from 'react';

const InputField = ({ label, type, name, value, onChange, placeholder, required = false, error = '', icon, onIconClick }) => {
  return (
    <div className="mb-4">
      <label className="block text-text text-m font-bold mb-2" htmlFor={name}>
        {label}
      </label>
      <div className="relative">
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-[1px] focus:ring-gray-400 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {icon && (
          <button
            type="button"
            onClick={onIconClick}
            className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            {icon}
          </button>
        )}
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default InputField;
